module.exports = __webpack_public_path__ + "img/source3_8.9d4200ad.png";